import React from 'react'

const InstagramIcon = (props) => (
  <svg height="388pt" viewBox="0 0 388 388" width="388pt" {...props}>
    <path d="M0 0v388h388V0zm364 364H24V24h340zm0 0" fill="#151515" />
    <path
      d="M256.426 68.035H131.578c-35.05 0-63.562 28.516-63.562 63.563v124.847c0 35.051 28.511 63.559 63.562 63.559h124.848c35.05 0 63.558-28.508 63.558-63.559V131.598c0-35.047-28.507-63.563-63.558-63.563zm36.14 188.41c0 19.93-16.214 36.145-36.14 36.145H131.578c-19.926 0-36.14-16.215-36.14-36.145V131.598c0-19.926 16.214-36.137 36.14-36.137h124.848c19.926 0 36.14 16.21 36.14 36.137zm0 0"
      fill="#FFF"
    />
    <path
      d="M260.98 142.547c-8.468 0-15.359-6.887-15.359-15.356 0-8.464 6.89-15.351 15.36-15.351s15.355 6.887 15.355 15.351c0 8.47-6.887 15.356-15.356 15.356zm0 0M193.996 129.129c-35.777 0-64.89 29.11-64.89 64.89s29.113 64.895 64.89 64.895c35.785 0 64.899-29.113 64.899-64.894 0-35.778-29.114-64.891-64.899-64.891zm0 102.371c-20.652 0-37.473-16.816-37.473-37.48 0-20.657 16.82-37.465 37.473-37.465 20.664 0 37.473 16.808 37.473 37.465 0 20.664-16.809 37.48-37.473 37.48zm0 0"
      fill="#FFF"
    />
  </svg>
)

export default InstagramIcon
